module.exports = __webpack_public_path__ + "img/032-entitled.e632f03f.png";